import { IBasicTableRow } from '../components/BasicTable';

interface IGroupedOfficials {
  supremeCourtRows: IBasicTableRow[];
  criminalCourtRows: IBasicTableRow[];
  edBoardRows: IBasicTableRow[];
  railroadRows: IBasicTableRow[];
}

export default function groupStateOfficials(
  rows: IBasicTableRow[]
): IGroupedOfficials {
  const supremeCourtRows: IBasicTableRow[] = [];
  const criminalCourtRows: IBasicTableRow[] = [];
  const edBoardRows: IBasicTableRow[] = [];
  const railroadRows: IBasicTableRow[] = [];

  rows.forEach(row => {
    if (row.body === 'Texas Supreme Court') {
      supremeCourtRows.push(row);
    } else if (row.body === 'Texas Court of Criminal Appeals') {
      criminalCourtRows.push(row);
    } else if (row.body === 'State Board of Education') {
      edBoardRows.push(row);
    } else if (row.body === 'Railroad Commission of Texas') {
      railroadRows.push(row);
    }
  });

  return { supremeCourtRows, criminalCourtRows, edBoardRows, railroadRows };
}
